import client from './client'
import type { Incident, IncidentResponse, SessionSummary } from '../types'

export async function getActiveIncident(): Promise<IncidentResponse | null> {
  const resp = await client.get<IncidentResponse>('/api/v1/incidents/active', {
    validateStatus: (s) => s === 200 || s === 204,
  })
  return resp.status === 204 ? null : resp.data
}

export async function getSessionSummary(month: string): Promise<SessionSummary> {
  const { data } = await client.get<SessionSummary>(`/api/v1/sessions/summary?month=${month}`)
  return data
}

export async function updateIncidentNotes(
  incidentId: string,
  body: { notes?: string; investigationMinutes?: number }
): Promise<Incident> {
  const { data } = await client.put<Incident>(`/api/v1/incidents/${incidentId}/notes`, body)
  return data
}

export async function deleteIncident(incidentId: string): Promise<void> {
  await client.delete(`/api/v1/incidents/${incidentId}`)
}

export async function confirmIncident(incidentId: string): Promise<void> {
  await client.put(`/api/v1/incidents/${incidentId}/confirm`)
}

export async function createIncident(body: {
  startedAt: string
  notes?: string
  investigationMinutes?: number
}): Promise<Incident> {
  const { data } = await client.post<Incident>('/api/v1/incidents', body)
  return data
}
